/**
 * ZoomX slot component.
 */
export const ZoomX = () => null;

ZoomX['displayName'] = 'ZoomX';
